/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useMemo, useState } from 'react';
import * as Sentry from '@sentry/browser';
import Add from '@mui/icons-material/Add';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import OpenInNew from '@mui/icons-material/OpenInNew';
import NotifyButton from '../NotifyButton';
import CustomLoader from '../CommonComponents/CustomLoader';
import ShopifyMoreOptions from './ShopifyMoreOptions';
import { useNurseryContext } from '../../contexts/NurseryContext';
const classes = {
    loaderRoot: (theme) => ({
        color: theme.palette.background.default,
        padding: theme.spacing(0, 0.65),
    }),
    select: {
        padding: 0,
        boxShadow: 'none',
        border: '1px solid #d8d8d8',
        '& ul': {
            padding: 0,
            backgroundColor: '#fff',
        },
    },
    menuItem: {
        color: '#5B6A74',
        padding: '15px 0 0',
        cursor: 'pointer',
        '& .item_wrapper': {
            borderBottom: '1px solid #d3d3d3',
            margin: '0 15px',
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            width: '100%',
            paddingBottom: '15px',
        },
        '& p': {
            marginBottom: 0,
            fontSize: '14px',
            fontWeight: 'bold',
            lineHeight: '19px',
        },
        '& span': {
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '20px',
        },
        '& .shopify_more_options': {
            display: 'flex',
            alignItems: 'center',
            padding: '0 12px 15px',
        },
    },
    noBorder: {
        border: 'none',
    },
    noMargin: {
        margin: 0,
    },
    hide: {
        display: 'none',
    },
};
const MORE_OPTIONS_VALUE = 'more-options';
const ShopifyBuy = ({ filterToCurrentNursery = true, notForSale, mainTitle = '', onAddToShopifyCart, plant: { variants, django_pk: djangoPk, affiliated_links: affiliatedLinks, nurseries, }, }) => {
    const { isNursery, nurseryName, nurserySlug } = useNurseryContext();
    const [selectedVariant, setSelectedVariant] = useState('none');
    const [addingToCart, setAddingToCart] = useState(false);
    const [openSelect, setOpenSelect] = useState(false);
    const [openOptions, setOpenOptions] = useState(false);
    const shopifyProduct = useMemo(() => {
        let product = variants.filter((variant) => variant.available);
        if (isNursery && filterToCurrentNursery) {
            product = product.filter((variant) => variant.fulfillment_service === nurserySlug);
        }
        return product;
    }, [variants, isNursery, filterToCurrentNursery, nurserySlug]);
    const filteredLinks = useMemo(() => {
        if (!affiliatedLinks)
            return [];
        if (isNursery && filterToCurrentNursery) {
            return affiliatedLinks.filter((item) => item.nursery.name === nurseryName);
        }
        return affiliatedLinks;
    }, [affiliatedLinks, isNursery, filterToCurrentNursery, nurseryName]);
    const isAffiliatedLink = selectedVariant !== 'none'
        && !shopifyProduct.find((product) => product.id === selectedVariant);
    const availableOptions = shopifyProduct.length + filteredLinks.length;
    const hasNothingForSale = availableOptions === 0;
    const getSaleUrl = () => {
        var _a, _b;
        return (_b = (_a = filteredLinks
            .find((link) => link.id === selectedVariant)) === null || _a === void 0 ? void 0 : _a.sale_url) !== null && _b !== void 0 ? _b : '';
    };
    const handleAddToCart = async (e) => {
        e.preventDefault();
        if (selectedVariant === 'none' && !openSelect) {
            setOpenSelect(true);
        }
        else {
            setAddingToCart(true);
            await onAddToShopifyCart({ id: selectedVariant }, 1, djangoPk);
            setAddingToCart(false);
        }
    };
    const handleChange = (event) => {
        const id = event.target.value;
        if (id === MORE_OPTIONS_VALUE) {
            setOpenOptions(true);
            return;
        }
        const item = [...shopifyProduct, ...filteredLinks]
            .find((option) => option.id === id);
        if (item)
            setSelectedVariant(item.id);
    };
    const closeSelect = () => {
        setOpenSelect(false);
    };
    useEffect(() => {
        if (hasNothingForSale && notForSale) {
            try {
                notForSale();
            }
            catch (error) {
                Sentry.captureException(error);
            }
        }
    }, [hasNothingForSale, notForSale]);
    return (React.createElement(React.Fragment, null,
        hasNothingForSale ? (React.createElement("div", { className: "notify_container" },
            React.createElement(NotifyButton, { showTitle: false, djangoPk: djangoPk, plantName: mainTitle }),
            (nurseries === null || nurseries === void 0 ? void 0 : nurseries.length) > 0 && (React.createElement(Box, { sx: [classes.menuItem, classes.noBorder, classes.noMargin] },
                React.createElement("div", { onClick: () => setOpenOptions(true), role: "button", className: "shopify_more_options" },
                    React.createElement(Add, { fontSize: "small", style: { marginRight: 5 } }),
                    React.createElement("p", null, "More Options")))))) : (React.createElement("div", { className: "shopify_btn" },
            React.createElement(Select, { open: openSelect, onClick: () => {
                    if (!openSelect)
                        setOpenSelect(true);
                }, onClose: closeSelect, onBlur: closeSelect, defaultValue: "none", id: "menu", MenuProps: {
                    sx: { paper: classes.select },
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    },
                    transformOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    },
                }, onChange: handleChange, className: "variant_dd_wrapper", inputProps: { 'aria-label': 'Without label' }, value: selectedVariant },
                React.createElement(MenuItem, { sx: [classes.menuItem, classes.hide], value: "none" },
                    React.createElement("p", { className: "plant_info" }, "Select a size"),
                    React.createElement("span", { className: "select_shipping_info" },
                        availableOptions,
                        ' ',
                        "option",
                        availableOptions > 1 ? 's' : '',
                        ' ',
                        "available")),
                shopifyProduct.map((item) => {
                    var _a;
                    return (React.createElement(MenuItem, { sx: classes.menuItem, key: item.id, value: item.id },
                        React.createElement("div", { className: "item_wrapper" },
                            React.createElement("p", { className: "plant_info" },
                                item.title,
                                ' ',
                                "| $",
                                item.price),
                            React.createElement("span", { className: "select_shipping_info" }, (_a = item === null || item === void 0 ? void 0 : item.nursery) === null || _a === void 0 ? void 0 : _a.shipping_info))));
                }),
                filteredLinks.map((link) => {
                    var _a, _b;
                    return (React.createElement(MenuItem, { sx: classes.menuItem, key: link.id, value: link.id },
                        React.createElement("div", { className: "item_wrapper" },
                            link.size || link.price ? (React.createElement("p", { className: "plant_info" },
                                link.size,
                                ' ',
                                "| $",
                                link.price)) : React.createElement("p", { className: "plant_info" }, (_a = link.nursery) === null || _a === void 0 ? void 0 : _a.name),
                            React.createElement("span", { className: "select_shipping_info" }, (_b = link === null || link === void 0 ? void 0 : link.nursery) === null || _b === void 0 ? void 0 : _b.shipping_info))));
                }),
                React.createElement(MenuItem, { sx: [classes.menuItem, classes.noBorder], value: MORE_OPTIONS_VALUE },
                    React.createElement("div", { role: "button", className: "shopify_more_options" },
                        React.createElement(Add, { fontSize: "small", style: { marginRight: 5 } }),
                        React.createElement("p", null, "More Options")))),
            isAffiliatedLink ? (React.createElement("a", { target: "_blank", rel: "noopener nofollow sponsored", href: getSaleUrl() },
                React.createElement("button", { type: "button", className: "btn primary" },
                    React.createElement(OpenInNew, { sx: { padding: 0, marginRight: 2 } }),
                    "Buy from nursery"))) : (React.createElement("button", { type: "button", className: "btn primary", id: "addcart_btn", onClick: handleAddToCart, disabled: addingToCart },
                React.createElement("img", { className: "add_to_cart", src: `${process.env.STATIC_PATH}/img/add-to-cart.png`, alt: "Add to cart" }),
                addingToCart ? (React.createElement(CustomLoader, { loaderSx: classes.loaderRoot, loaderAttributes: { size: 20, thickness: 5 } })) : 'Add to Cart')))),
        openOptions && (React.createElement(ShopifyMoreOptions, { openOptions: openOptions, setOpenOptions: setOpenOptions, djangoPk: djangoPk, variants: variants.filter((variant) => variant.available), affiliatedLinks: affiliatedLinks !== null && affiliatedLinks !== void 0 ? affiliatedLinks : [], onAddToShopifyCart: onAddToShopifyCart, partnersData: nurseries !== null && nurseries !== void 0 ? nurseries : [], plantTitle: mainTitle }))));
};
export default ShopifyBuy;
